import style from './componentCss/WhiteSpace.module.css'

const WhiteSpace = ({ paddingTop }) => {
  return (
    <div
      className={style.container}
      style={paddingTop ? { '--padding-top': paddingTop } : {}}
    >
    </div>
  );
};

export default WhiteSpace;
